// TODO: make prettier
export function NotFound() {
  return <p>Not Found</p>;
}
